import { render, staticRenderFns } from "./title_and_name.vue?vue&type=template&id=73083d37&scoped=true&"
import script from "./title_and_name.vue?vue&type=script&lang=js&"
export * from "./title_and_name.vue?vue&type=script&lang=js&"
import style0 from "./title_and_name.vue?vue&type=style&index=0&id=73083d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73083d37",
  null
  
)

export default component.exports